import AdminLayout from "../../../component/AdminLayout";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Button, Card, Col, Row, Select } from "antd";
import { useEffect, useState } from "react";
import {
  GetDesignationCategories,
  GetSoftwareLicensingDashboard,
} from "../../../API/api";
import { enqueueSnackbar } from "notistack";

type SoftwareLicenseCountList = {
  softwareId: number;
  softwareName: string;
  softwareLicensingCount: number;
};
const SoftwareDashboard = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [designationCategoryList, setDesignationCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategry] = useState<number>();
  const [softwareLicenseCount, setSoftwareLicenseCount] = useState<
    SoftwareLicenseCountList[]
  >([]);
  useEffect(() => {
    fetchDesignationCategory();
    fetchSoftwareLicensingDashboard();
  }, []);
  const fetchDesignationCategory = async () => {
    try {
      setIsLoading(true);
      const response = await GetDesignationCategories();
      const newData = response.data.map((version: any, index: number) => ({
        value: version.categoryId,
        label: version.categoryName,
        key: version.categoryId,
      }));

      setDesignationCategoryList(newData);
      setIsLoading(false);
    } catch (error: any) {
      enqueueSnackbar(error, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      setIsLoading(false);
    }
  };
  const fetchSoftwareLicensingDashboard = async () => {
    try {
      setIsLoading(true);
      let categoryvalue: number;
      if (!selectedCategory) categoryvalue = 0;
      else categoryvalue = selectedCategory;
      const response = await GetSoftwareLicensingDashboard(categoryvalue);
      const newData = response.data.map(
        (softwareCountList: any, index: number) => ({
          ...softwareCountList,
          key: softwareCountList.softwareId,
        })
      );
      setSoftwareLicenseCount(newData);
      setIsLoading(false);
    } catch (error: any) {
      enqueueSnackbar(error, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      setIsLoading(false);
    }
  };
  const handleCategoryChange = () => {
    if (selectedCategory) {
      fetchSoftwareLicensingDashboard();
    }
  };
  const filterOption = (
    input: string,
    option?: { label: string; value: number }
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  const handleSelection = (rowData: any) => {
    setSelectedCategry(rowData);
  };

  return (
    <>
      {" "}
      <AdminLayout>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme: any) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <div>
          <div className="employee-table-header ">
            <Row
              gutter={16}
              style={{ alignItems: "center", margin: "12px 16px" }}
            >
              <Col className="gutter-row" lg={12} sm={24}>
                <h3 className="bottom-margin-mob" style={{ float: "left" }}>
                  Software Licensing Dashboard
                </h3>
              </Col>
              <Col
                className="gutter-row pm-search-flex"
                lg={{ span: 10, offset: 2 }}
                sm={24}
                xs={24}
                style={{ display: "flex" }}
              >
                <Select
                  style={{ width: "100%" }}
                  value={selectedCategory}
                  placeholder="Select Designation Category"
                  options={designationCategoryList}
                  filterOption={filterOption}
                  onSelect={handleSelection}
                  showSearch
                />
                <Button
                  onClick={handleCategoryChange}
                  type="primary"
                  style={{ marginLeft: 10 }}
                  size="small"
                >
                  Apply
                </Button>
              </Col>
            </Row>
          </div>
          <div>
            <Row gutter={16}>
              {softwareLicenseCount.map((software, index) => (
                <Col key={index} lg={8} md={24} xs={24}>
                  <div className="report-card">
                    <Card title={software.softwareName} bordered={false}>
                      {/* Use software properties to populate the card content */}
                      <hr style={{ borderColor: "#00000012" }} />
                      <p style={{ marginTop: "20px" }}>
                        License Count: {software.softwareLicensingCount}
                      </p>
                    </Card>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      </AdminLayout>
    </>
  );
};
export default SoftwareDashboard;
